module.exports = __webpack_public_path__ + "img/account-choose-icon-dark.1f12fcae.svg";